import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { StockGroupByBloccoModel } from 'Magazzino/Models/StockGroupByBloccoModel';
import { List, Pagination, Space, Spin, message } from 'antd';

import Configurazione from '../../Configurazione';
import Footer from '../../Footer';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import FiltriMagazzino, { filtriFields } from '../FiltriMagazzino';
import BloccoCard from '../MagazzinoProprieta/BloccoCardMagProp';
import HeaderBarMagazzino from '../MagazzinoProprieta/HeaderBarMagazzino';
import { GestionePreferiti } from './GestionePreferiti';

export default function Magazzino() {
    const [isRunning, setIsunning] = useState(false);
    const [totalRighe, setTotalRighe] = useState(1);
    const [data, setData] = useState<StockGroupByBloccoModel[]>([]);

    const [querystring, setQuerystring] = useSearchParams();

    const topRef = useRef<HTMLDivElement | null>(null);
    // Funzione per scorrere fino alla parte superiore
    const scrollToTop = () => {
        if (topRef.current) {
            topRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        fetchData(querystring, 1);
    }, []);

    async function fetchData(querystring: URLSearchParams, cpage: number) {
        setIsunning(true);

        try {
            const dt = {
                idSocieta: Configurazione().idsocieta,
                idQualita: querystring.getAll('iq'),
                codFinitura: querystring.getAll('cf'),
                numeroBlocco: querystring.get('nb'),
                numeroBloccoFornitore: querystring.get('nbf'),
                indice: (cpage - 1) * Configurazione().maxResultsPerPage,
                numeroRighe: Configurazione().maxResultsPerPage,
            };
            const result = await api.post('Magazzino/StockGroupByBlocco', dt);

            if (result != null) {
                if (Array.isArray(result.data) && result.data?.length > 0) {
                    setData(result.data);
                    setTotalRighe(result.data[0].totaleRighe);
                } else {
                    setData([]);

                    setTotalRighe(1);
                }
            } else {
                setData([]);
                setTotalRighe(1);
            }
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsunning(false);
        }
    }

    function onConfirmFiltri(e: filtriFields) {
        const pr = new URLSearchParams();

        e.codFinitura ? e.codFinitura.forEach((value) => pr.append('cf', value)) : null;
        e.idQualita ? e.idQualita.forEach((value) => pr.append('iq', value.toString())) : null;
        e.numeroBlocco ? pr.append('nb', e.numeroBlocco) : null;
        e.numeroBloccoFornitore ? pr.append('nbf', e.numeroBloccoFornitore) : null;
        e.numFattura ? pr.append('nf', e.numFattura) : null;
        e.fatturate ? pr.append('f', e.fatturate) : null;

        setQuerystring(pr);

        fetchData(pr, 1);
    }

    function onChangePage(page: any) {
        fetchData(querystring, page);
        scrollToTop();
    }

    return (
        <div>
            <div ref={topRef}></div>
            <HeaderBarMagazzino descrizione="Magazzino" menuSelezionato="MagazzinoClienti"></HeaderBarMagazzino>
            <Space className="App-body" direction="vertical">
                <FiltriMagazzino
                    numeroBloccoVisible={true}
                    numeroBloccoFornitoreVisible={true}
                    fatturazioneVisible={false}
                    finituraVisible={true}
                    periodoVisible={false}
                    qualitaVisible={true}
                    dataIni={null}
                    params={querystring}
                    contoTerzi={false}
                    onconfirm={(e: filtriFields) => onConfirmFiltri(e)}
                ></FiltriMagazzino>
                <hr></hr>
                <Spin spinning={isRunning} size="large">
                    <List
                        style={{ alignSelf: 'center', textAlign: 'center' }}
                        dataSource={data}
                        grid={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
                        renderItem={(item: any) => {
                            return <BloccoCard stock={item} isCliente={false} params={querystring}></BloccoCard>;
                        }}
                    ></List>
                    <div style={{ marginBottom: '50px', textAlign: 'center' }}>
                        <Pagination
                            total={totalRighe}
                            defaultPageSize={Configurazione().maxResultsPerPage}
                            onChange={onChangePage}
                        />
                    </div>
                </Spin>
            </Space>
            <Footer></Footer>
        </div>
    );
}
